// React & Hooks
import { memo } from "react";

// UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// Project Specific Constants & Types
import { initialDataWithPagination } from "services/api/consts";
import { CALCULATION_TIRE_SEARCH_COLUMNS } from "./consts";
import { TireSearchResultsProps } from "./types";


const TireSearchResults: React.FC<TireSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;


  return (
    <>
      <TableSearch
        columns={CALCULATION_TIRE_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(TireSearchResults);
